import {Component, Input} from '@angular/core';
import {BusinessDirectory} from '../models/business-directory';
import {categoryName, initialsOf, lookingForLabel} from '../biz-directory/biz-categories';

/** One listing as a card; used by the directory grid, the carousels and "similar businesses". */
@Component({
    selector: 'app-biz-card',
    templateUrl: './biz-card.component.html',
    styleUrls: ['./biz-card.component.css']
})
export class BizCardComponent {
    @Input({required: true}) biz!: BusinessDirectory;
    @Input() chapterName = '';

    category = categoryName;
    initials = initialsOf;
    lookingFor = lookingForLabel;

    get location(): string {
        return [this.biz.city, this.biz.state].filter(Boolean).join(', ');
    }
}
